import { useEffect } from "react";
import useBreadcrumbs from "../Breadcrumbs/useBreadcrumbs";

function Page({ icon, title, url, breadcrumbs = [], children, ...props }) {
	const { setBreadcrumbs } = useBreadcrumbs();
	useEffect(() => {
		setBreadcrumbs([{ icon }, { label: title, url }, ...breadcrumbs]);
		// eslint-disable-next-line
	}, [icon, title, url, JSON.stringify(breadcrumbs)]);

	return (
		<div id="main-layout" className="relative" {...props}>
			{children}
		</div>
	);
}

export default Page;
